import { makeStyles } from 'tss-react/mui';

import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';

const useStyles = makeStyles({ name: 'MuiFooter' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    footer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'black',
      paddingTop: typography.pxToRem(85),
      paddingBottom: typography.pxToRem(120),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingTop: typography.pxToRem(63),
      },
    },
    footerContent: {
      width: '100%',
      maxWidth: typography.pxToRem(1440),
    },
    logo: {
      margin: `${typography.pxToRem(12)} ${typography.pxToRem(5)}`,
    },
    socialIcons: {
      display: 'flex',
      fontSize: typography.pxToRem(20),
      '& a:not(:last-child)': {
        marginRight: typography.pxToRem(20),
      },
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(46),
        paddingRight: typography.pxToRem(46),
        marginBottom: typography.pxToRem(75),
      },
    },
    linkSection: {
      display: 'flex',
      color: 'white',
      justifyContent: 'flex-end',
      marginBottom: typography.pxToRem(300),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        flexDirection: 'column',
        marginBottom: typography.pxToRem(20),
        '& .MuiPaper-root': {
          borderBottom: `1px solid rgba(255, 251, 240, 0.2)`,
          backgroundColor: 'black',
        },
      },
    },
    linkColumn: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: typography.pxToRem(80),
    },
    linkCategory: {
      ...type['24_medium'],
      color: brandColors.offWhite,
      marginBottom: typography.pxToRem(30),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        marginBottom: 0,
        fontWeight: 500,
        fontSize: typography.pxToRem(14),
        lineHeight: typography.pxToRem(16),
        letterSpacing: '-0.02rem',
      },
    },
    linkText: {
      ...type['16_medium'],
      color: brandColors.offWhite,
      marginBottom: typography.pxToRem(12),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontWeight: 400,
        fontSize: typography.pxToRem(12),
      },
    },
    bottomSection: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: '-10px',
      alignItems: 'center',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(46),
        paddingRight: typography.pxToRem(46),
      },
    },
    socialIcon: {
      color: brandColors.offWhite,
    },
    legal: {
      ...type['16_medium'],
      color: brandColors.offWhite,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontWeight: 500,
        fontSize: typography.pxToRem(14),
        lineHeight: typography.pxToRem(24),
        letterSpacing: '-0.02rem',
        [breakpoints.down(ScreenSize.MEDIUM)]: {
          paddingLeft: typography.pxToRem(46),
          paddingRight: typography.pxToRem(46),
        },
      },
    },
    copyright: {
      ...type['16_medium'],
      color: brandColors.offWhite,
      marginBottom: typography.pxToRem(50),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        fontWeight: 500,
        fontSize: typography.pxToRem(14),
        lineHeight: typography.pxToRem(24),
        letterSpacing: '-0.02rem',
        [breakpoints.down(ScreenSize.MEDIUM)]: {
          paddingLeft: typography.pxToRem(46),
          paddingRight: typography.pxToRem(46),
        },
      },
    },
    accordion: {
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingLeft: typography.pxToRem(46),
        paddingRight: typography.pxToRem(46),
      },
      '& .MuiAccordionSummary-root': {
        padding: 0,
      },
    },
  })
);

export default useStyles;
